import {Component} from '@angular/core';
import {EnvironmentService} from '../../../core/services/environment.service';

@Component({
  templateUrl: './wizard.component.html'
})
export class WizardComponent {
  imageName = 'beta_solid.svg';

  constructor(private environmentService: EnvironmentService) {
  }

  get betaTagUrl(): string {
    return this.environmentService.assetsUrl + '/' + this.imageName;
  }

  get isBeta(): boolean {
    return this.environmentService.isBeta;
  }
}
